<div mat-dialog-title>
  Login
  <span class=" float-right" (click)="cancel()">
    <i class="fa fa-close"></i>
  </span>
</div>
<mat-dialog-content>
  <div class="row form-group">
    <div class="col-md-5 align-self-center px-4 ">
      <span class="form-group">
        Don't have an account?
      </span>
      <button (click)="signUpForm()" class="btn mt-2 js-btn-cancel w-100 p-1 ">
        Register
      </button>
    </div>
    <div class="col-lg-7 registration " style="background: white;">
      <div class="login-form" *ngIf="form_flag==1">
        <form [formGroup]="login_form">
          <div class="row">
            <div class="col-lg-12">
              <!-- <input type="text" class="form-control" formControlName="username"
                                    placeholder="Email ID" (ngModelChange)="loginMessageChange($event)"> -->
              <mat-form-field>
                <mat-label> {{field_config_access && field_config_access['LOGIN_loginId']?
                  field_config_access['LOGIN_loginId'].label :'Email ID'}} </mat-label>
                <input name="email" [required]="true" class="w-93" matInput [placeholder]="field_config_access && field_config_access['LOGIN_loginId']?
                field_config_access['LOGIN_loginId'].label :'Enter Email ID'" formControlName="loginId">
                <mat-error *ngIf="login_form.controls.loginId.errors">
                  <div *ngIf="login_form.controls.loginId.errors.required">Email ID is required
                  </div>
                  <div *ngIf="login_form.controls.loginId.errors.pattern">Enter valid Email
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12 " *ngIf="authType!=4;">
              <app-mask-password [form_group]="login_form" [form_control]="'password'" [design_pattern]="2"
                [label]="'LOGIN.password'|translate" [validationScript]="passValidation" [floatLabel]="'none'"
                [placeholder]="'LOGIN.enter_password'|translate">
              </app-mask-password>
            </div>
            <div class="col-md-12" *ngIf="authType==4 && otp_send">
              <app-mask-password [form_group]="login_form" [form_control]="'otp'" [label]="'OTP'|translate"
                [design_pattern]="2" [validationScript]="passValidation" [floatLabel]="'none'"
                [placeholder]="'Enter OTP'|translate">
              </app-mask-password>
            </div>
            <div class="col-md-12 fp-container form-group" *ngIf="authType !=4">
              <a class="forgot-password link" (click)="forgotPassword()">
                {{"LOGIN.Forgot password?"|translate}}
              </a>
            </div>

            <div class="col-md-12 text-right form-group" *ngIf="authType ==4 && otp_send">
              <a class="forgot-password " [ngClass]="{'link':!timer}" (click)="timer?'':resendOTP()">
                {{"Resend OTP?"|translate}}
                <ng-container *ngIf="timer">
                  ({{this.timer}})s
                </ng-container>
              </a>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-12 form-group ">
              <div class="tm-captcha" #recaptcha id="tm-recaptcha"></div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-lg-12">
              <button [disabled]="loading" (click)="loginWithUsernamePassword()"
                class="btn btn-info w-100 p-1 login-btn ">
                <div *ngIf="loading" style="text-align: center;">
                  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
                <span *ngIf="!loading">
                  Login
                </span>
              </button>
            </div>
          </div>
        </form>

      </div>


      <!-- </div> -->
    </div>

  </div>
</mat-dialog-content>